import { render, staticRenderFns } from "./EAcompanhamentosTab.vue?vue&type=template&id=6aa37aa6"
import script from "./EAcompanhamentosTab.vue?vue&type=script&lang=js"
export * from "./EAcompanhamentosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports